<template>
  <main class="card-columns">
    <BigNumber
      v-if="feature && feature.usual_residence_population_data.length > 0"
      :value="feature.usual_residence_population_data[0].count"
      :title="$t('Feature.CensusResults.usual_residence_population')" />
    <AgeGroups
      v-if="feature && feature.age_five_year_groups_data.length > 0"
      :queryData="feature.age_five_year_groups_data" />
    <HorizontalBars
      v-if="feature && feature.gender_data.length > 0"
      :queryData="feature.gender_data"
      sorted=false
      :title="$t('Feature.CensusResults.gender')"
      codeEnumScope="Enums.genders" />
    <HorizontalBars
      v-if="feature && feature.ethnicity_data.length > 0"
      :queryData="feature.ethnicity_data"
      sorted=true
      :title="$t('Feature.CensusResults.ethnic_groups')"
      codeEnumScope="Enums.ethnic_groups" />
    <BigNumber
      v-if="feature && feature.census_night_population_data.length > 0"
      :value="feature.census_night_population_data[0].count"
      :title="$t('Feature.CensusResults.census_night_population')" />
  </main>
</template>

<script>
import gql from "graphql-tag";
import AgeGroups from "@/components/Visuals/AgeGroups";
import HorizontalBars from "@/components/Visuals/HorizontalBars";
import BigNumber from "@/components/Visuals/BigNumber";

export default {
  components: { AgeGroups, HorizontalBars, BigNumber },
  props: {
    uuid: String,
    year: String
  },
  apollo: {
    feature: {
      query: gql`query fetchfeature($id: uuid!, $year: String){
        feature: features_by_pk(id: $id){
          id
          usual_residence_population_data(where: {year: {_eq: $year}, available: {_eq: true}}){
            count
          }
          census_night_population_data(where: {year: {_eq: $year}, available: {_eq: true}}){
            count
          }
          ethnicity_data(where: {year: {_eq: $year}, available: {_eq: true}}){
            code
            count
          }
          gender_data(where: {year: {_eq: $year}, available: {_eq: true}}){
            code
            count
          }
          age_five_year_groups_data(where: {year: {_eq: $year}, available: {_eq: true}}){
            code
            count
          }
        }
      }`,
      variables(){
        return {
          id: this.uuid,
          year: this.year
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "~bootstrap/scss/_functions.scss";
  @import "~bootstrap/scss/_variables.scss";
  @import "~bootstrap/scss/mixins/_breakpoints.scss";

  .card-columns {
    @include media-breakpoint-up(xs) {
      column-count: 1;
    }

    @include media-breakpoint-up(md) {
      column-count: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Feature/CensusResults.vue